import React, { useState } from 'react';
import { SelectBox } from 'devextreme-react/select-box';
import { Validator, RequiredRule } from 'devextreme-react/validator';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import '../../scss/controls/_dropdownbox.scss';

interface DropBoxProps {
    id: string;
    value: any;
    readOnly?: boolean;
    onChange: (value: string) => void;
    label?: string;
    helperText?: string;
    required?: boolean;
    children?: React.ReactNode;
    validator?: React.ReactNode;
    dataSource?: any;
    displayExpr?: string;
    valueExpr?: string;
    placeholder?: string;
}

export const DropDownBox: React.FC<DropBoxProps> = ({
    id,
    value,
    readOnly = false,
    onChange,
    label,
    helperText,
    required = false,
    children,
    validator,
    dataSource,
    displayExpr,
    valueExpr,
    placeholder,
}) => {
    const [dropdownVisible, setDropdownVisible] = useState(false);

    const handleValueChanged = (e: any) => {
        onChange(e.value);
    };

    const renderDropDownIcon = () => {
        return (
            <div style={{ alignContent: 'center', paddingTop: '5px' }}>
                <FontAwesomeIcon
                    icon={dropdownVisible ? faChevronUp : faChevronDown}
                    aria-hidden='true'
                />
            </div>
        );
    };

    return (
        <div className='dropdownbox-container'>
            {label && <label className='dropdownbox-label'>{label}</label>}
            <div
                className='dropdownbox-wrapper'
                style={{ position: 'relative' }}
            >
                <SelectBox
                    id={id}
                    value={value}
                    readOnly={readOnly}
                    onValueChanged={handleValueChanged}
                    dataSource={dataSource}
                    displayExpr={displayExpr}
                    valueExpr={valueExpr}
                    className='dropdownbox-input'
                    onOpened={(e) => setDropdownVisible(true)}
                    onClosed={(e) => setDropdownVisible(false)}
                    dropDownButtonRender={renderDropDownIcon}
                    placeholder={placeholder}
                >
                    <Validator>
                        {required && <RequiredRule message='This field is required' />}
                        {validator}
                    </Validator>
                </SelectBox>
            </div>
            {helperText && <div className='dropdownbox-helper'>{helperText}</div>}
            {children && <div className='dropdownbox-children'>{children}</div>}
        </div>
    );
};
